import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from './api.service';

export interface AssetModel {
  id: string;
  name: string;
  workspaceId: string;
  assetList: string;
  assets: Array<{
    id: string;
    title?: string;
    detail?: string;
    funnel?: string;
    [key: string]: any;
  }>;
}

@Injectable({
  providedIn: 'root',
})
export class AssetListService {
  constructor(private readonly apiService: ApiService) {}

  getAssetById(assetListId: string) {
    return this.apiService.httpGet(`/api/campaigns/asset-list/${assetListId}/project`);
  }

  getAffectedAssetByCampaignId(campaignId: string) {
    return this.apiService.httpGet(`/api/campaigns/asset-list/project/by-campaign/${campaignId}`);
  }

  updateAssetListStatusOrDelivery(data) {
    return this.apiService.httpPost(`/api/campaigns/asset-list/project`, data);
  }

  getAssetListSummary(campaignId: string, milestoneId: string) {
    return this.apiService.httpGet(`/api/campaigns/asset-list/summary-by-milestone/${campaignId}/${milestoneId}`);
  }

  getAssetModel(workspaceId: string): Observable<AssetModel[]> {
    return this.apiService
      .httpGet(`/api/campaigns/asset-list/model/${workspaceId}`)
      .pipe(map((response: unknown) => response as AssetModel[]));
  }

  createAssetModel(model: Partial<AssetModel>): Observable<AssetModel> {
    return this.apiService
      .httpPost('/api/campaigns/asset-list/models', model)
      .pipe(map((response: unknown) => response as AssetModel));
  }

  updateAssetModel(model: Partial<AssetModel>): Observable<AssetModel> {
    return this.apiService
      .httpPut(`/api/campaigns/asset-list/models/${model.id}`, model)
      .pipe(map((response: unknown) => response as AssetModel));
  }

  deleteAssetModel(modelId: string): Observable<void> {
    return this.apiService.httpDelete(`/api/campaigns/asset-list/models/${modelId}`).pipe(map(() => void 0));
  }
  //#endregion
}
